import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {FormsService} from '../../../visits/forms/forms.service';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';
import {IdName} from '../../common-interfaces';


@Component({
    selector: 'select-form-dialog',
    templateUrl: './select-form-dialog.component.html',
    styleUrls: ['./select-form-dialog.component.scss'],
    standalone: false
})
export class SelectFormDialogComponent implements OnInit, OnDestroy {

  private destroyed$ = new Subject<void>();
  public form: FormGroup;
  pageTitle = this.translateService.stream(marker('Select Form'));
  aforms: IdName[];

  constructor(
    public dialogRef: MatDialogRef<SelectFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { storeId?: number, storeVisitId?: number},
    private fb: FormBuilder,
    private router: Router,
    private translateService: TranslateService,
    private formsService: FormsService,
  ) {

  }

  ngOnInit(): void {
    this.form = this.fb.group({
      aform: [ '', [Validators.required]],
    });

    this.formsService.getStoreFormsFiltered(this.data.storeId)
    .subscribe(forms => this.aforms = forms);
  }

  save() {
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onChanged(formId: number) {
    this.dialogRef.close(false);
    this.router.navigate(['/visits/forms/:storeFormId/startStoreVisit/:storeId',
      {storeFormId: formId, storeId: this.data.storeId},
    ],
    {
      queryParams: {storeVisitId: this.data.storeVisitId},
    });
  }

  close() {
    this.form.reset();
    this.dialogRef.close(false);
  }


}
